import { accountConstants } from "../_constants";

export const accountListRequest = (payload) => {
  return {
    type: accountConstants.ACCOUNT_LIST_REQUEST,
    payload,
  };
};

export const accountListComplete = (payload) => {
  return {
    type: accountConstants.ACCOUNT_LIST_COMPLETE,
    payload,
  };
};

export const accountListError = (payload) => {
  return {
    type: accountConstants.ACCOUNT_LIST_ERROR,
    payload,
  };
};

export const ePassbookListRequest = (payload) => {
  return {
    type: accountConstants.EPASSBOOK_LIST_REQUEST,
    payload,
  };
};

export const ePassbookListComplete = (payload) => {
  return {
    type: accountConstants.EPASSBOOK_LIST_COMPLETE,
    payload,
  };
};

export const ePassbookListError = (payload) => {
  return {
    type: accountConstants.EPASSBOOK_LIST_ERROR,
    payload,
  };
};

export const accountHistoryListRequest = (payload) => {
  return {
    type: accountConstants.ACCOUNT_HISTORY_LIST_REQUEST,
    payload,
  };
};

export const accountHistoryListComplete = (payload) => {
  return {
    type: accountConstants.ACCOUNT_HISTORY_LIST_COMPLETE,
    payload,
  };
};

export const accountHistoryListError = (payload) => {
  return {
    type: accountConstants.ACCOUNT_HISTORY_LIST_ERROR,
    payload,
  };
};

export const accountDetailsRequest = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DETAILS_REQUEST,
    payload,
  };
};

export const accountDetailsComplete = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DETAILS_COMPLETE,
    payload,
  };
};

export const accountDetailsError = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DETAILS_ERROR,
    payload,
  };
};

export const eligibleCasaListRequest = (payload) => {
  return {
    type: accountConstants.GET_ELIGIBLE_CASA_LIST_REQUEST,
    payload,
  };
};

export const eligibleCasaListComplete = (payload) => {
  return {
    type: accountConstants.GET_ELIGIBLE_CASA_LIST_COMPLETE,
    payload,
  };
};

export const eligibleCasaListError = (payload) => {
  return {
    type: accountConstants.GET_ELIGIBLE_CASA_LIST_ERROR,
    payload,
  };
};

export const savingAccountsOpenInitiateRequest = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST,
    payload,
  };
};

export const savingAccountsOpenInitiateComplete = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_COMPLETE,
    payload,
  };
};

export const savingAccountsOpenInitiateError = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_ERROR,
    payload,
  };
};

export const savingAccountsOtpResendRequest = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_RESEND_REQUEST,
    payload,
  };
};

export const savingAccountsOtpResendComplete = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const savingAccountsOtpResendError = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_RESEND_ERROR,
    payload,
  };
};

export const savingAccountsOtpConfirmationRequest = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST,
    payload,
  };
};

export const savingAccountsOtpConfirmationComplete = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_COMPLETE,
    payload,
  };
};

export const savingAccountsOtpConfirmationError = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_ERROR,
    payload,
  };
};

export const savingAccountsReceiptRequest = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_RECEIPT_REQUEST,
    payload,
  };
};

export const savingAccountsReceiptComplete = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_RECEIPT_COMPLETE,
    payload,
  };
};

export const savingAccountsReceiptError = (payload) => {
  return {
    type: accountConstants.SAVING_ACCOUNTS_RECEIPT_ERROR,
    payload,
  };
};

export const setSelectedSavingsDebitAccount = (payload) => {
  return {
    type: accountConstants.SET_SELECTED_SAVINGS_DEBIT_ACCOUNT,
    payload,
  };
};

export const clearSavingAccounts = (payload) => {
  return {
    type: accountConstants.CLEAR_SAVING_ACCOUNTS,
    payload,
  };
};

export const setSavingAccountsProductType = (payload) => {
  return {
    type: accountConstants.SET_SAVING_ACCOUNT_PRODUCT_TYPE,
    payload,
  };
};

export const setSavingAccountsProductCode = (payload) => {
  return {
    type: accountConstants.SET_SAVING_ACCOUNT_PRODUCT_CODE,
    payload,
  };
};

export const setSavingAccountsAmount = (payload) => {
  return {
    type: accountConstants.SET_SAVING_ACCOUNT_AMOUNT,
    payload,
  };
};

export const setSavingAccountFormChanged = (payload) => {
  return {
    type: accountConstants.SET_SAVING_ACCOUNT_FORM_CHANGED,
    payload,
  };
};

export const setActiveAccountTab = (payload) => {
  return {
    type: accountConstants.SET_ACTIVE_TAB,
    payload,
  };
};

export const clearAccountDetails = () => {
  return {
    type: accountConstants.CLEAR_ACCOUNT_DETAILS,
  };
};

export const downloadAccountStatementRequest = (payload) => {
  return {
    type: accountConstants.DOWNLOAD_ACCOUNT_STATEMENT_REQUEST,
    payload,
  };
};

export const downloadAccountStatementComplete = (payload) => {
  return {
    type: accountConstants.DOWNLOAD_ACCOUNT_STATEMENT_COMPLETE,
    payload,
  };
};

export const downloadAccountStatementError = (payload) => {
  return {
    type: accountConstants.DOWNLOAD_ACCOUNT_STATEMENT_ERROR,
    payload,
  };
};